<footer [ngClass]="customFooter" class="footer">
    <div class="container footer-padding">
        <div class="footer-first-content">
            <p>© B3 Way</p>
            <span>Versão {{ version }} | {{currentYear}} | Todos os direitos reservados</span>
        </div>
        <span class="footer-mobile-line"></span>
        <div class="footer-second-content">
            <a href="">Política de privacidade</a>
            <a href="">termos de serviço</a>
        </div>
    </div>
</footer>
